// https://kgf.cic.kz/api/get-member-by-email-and-phone?last_name=yensepbay&phone=77027502628&email=yensepbay@gmail.com&hash=37bab7b795c0348f5b95ef93823477ac
import axios from 'axios';
const dataFetching = axios.create({
    baseURL: 'https://kgf.cic.kz/api',
});
export default dataFetching;